import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["video", "poster"];

  connect() {
    this.play();
  }

  play() {
    if (!this.hasVideoTarget) return;

    const video = this.videoTarget;

    video
      .play()
      .then(() => {
        this.hidePoster();
      })
      .catch(() => {
        this.showPoster();
      });
  }

  ended() {
    this.showPoster();
  }

  clickPoster() {
    if (!this.hasVideoTarget) return;

    const video = this.videoTarget;
    video.currentTime = 0;
    this.hidePoster();
    video.play().catch(() => {
      this.showPoster();
    });
  }

  hidePoster() {
    if (this.hasVideoTarget) {
      this.videoTarget.classList.remove("hidden");
    }
    if (this.hasPosterTarget) {
      this.posterTarget.classList.add("hidden");
    }
  }

  showPoster() {
    if (this.hasVideoTarget) {
      this.videoTarget.classList.add("hidden");
    }
    if (this.hasPosterTarget) {
      this.posterTarget.classList.remove("hidden");
    }
  }
}
